import SectionHeading from '@/components/base/SectionHeading';
import { testimonials } from '@/mocks/homeData';

const principles = [
  { icon: 'ri-shield-check-line', title: '区分事实与传闻', desc: '能核实的写来源，无法核实的明确标注为「传闻」。' },
  { icon: 'ri-shield-user-line', title: '保护当事人', desc: '涉及普通人的故事统一化名，模糊具体门牌与联系方式。' },
  { icon: 'ri-scales-3-line', title: '不做道德审判', desc: '只梳理来龙去脉，把判断权留给读者。' },
  { icon: 'ri-refresh-line', title: '存疑即回访', desc: '出现新线索时，回头更新原稿而不是再写一篇。' },
];

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto px-4 md:px-10">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <SectionHeading
              eyebrow="ABOUT US"
              title="我们只做一件事：把怪事讲清楚"
              desc="「美日吃瓜」是一个专注美国与日本社会奇闻的内容频道，不做猎奇标题党，只把每个故事的线索、说法和疑点摆到台面上。"
            />
            <p className="mt-6 text-sm leading-8 text-foreground-600">
              我们相信，一件离奇的事之所以值得读，不是因为吓人，而是因为它照出了一个社会日常运转的缝隙。
              高密度都市里的都市怪谈，和地广人稀处的孤立叙事，讲的其实都是人怎么面对无法解释的事。
            </p>
            <p className="mt-4 text-sm leading-8 text-foreground-600">
              所以我们的每一篇收录，都会尽量写清楚「发生了什么」和「大家怎么说」——这两件事，我们从不混着写。
            </p>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {principles.map((p) => (
                <div key={p.title} className="rounded-lg border border-foreground-950/10 bg-background-100 p-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-lg text-secondary-700">
                    <i className={p.icon}></i>
                  </span>
                  <h4 className="mt-3 font-heading text-sm font-bold text-foreground-950">{p.title}</h4>
                  <p className="mt-2 text-xs leading-6 text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <h3 className="font-heading text-lg font-bold text-foreground-950">
              <a href="#about" className="transition-colors hover:text-primary-600">读者怎么说</a>
            </h3>
            <div className="mt-6 space-y-5">
              {testimonials.map((t) => (
                <figure
                  key={t.name}
                  className="flex flex-col gap-4 rounded-lg border border-foreground-950/10 bg-background-100 p-6 sm:flex-row sm:items-start"
                >
                  <img
                    src={t.avatar}
                    alt={`读者 ${t.name} 头像`}
                    title={`读者 ${t.name} · 美日吃瓜`}
                    className="h-14 w-14 shrink-0 rounded-full object-cover object-top"
                  />
                  <div>
                    <blockquote className="text-sm leading-8 text-foreground-800">「{t.text}」</blockquote>
                    <figcaption className="mt-3 text-xs text-foreground-500">
                      <span className="font-medium text-foreground-900">{t.name}</span> · {t.role}
                    </figcaption>
                  </div>
                </figure>
              ))}
            </div>

            <div className="mt-8 overflow-hidden rounded-lg border border-foreground-950/10">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cream%20desk%20with%20stacked%20archival%20folders%20and%20labeled%20index%20cards%2C%20a%20cup%20of%20tea%2C%20vermillion%20red%20stamps%2C%20calm%20editorial%20workbench%20atmosphere%2C%20soft%20natural%20light&width=1200&height=500&seq=chigua-about-01&orientation=landscape"
                alt="美日吃瓜编辑组的资料整理工作区"
                title="内容整理流程 · 美日吃瓜"
                className="h-52 w-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}